import i18next from 'i18next';

i18next.addResources('es_CL', 'SideBarItem', {
  created: 'Por aceptar',
  preparing: 'Preparación',
  ready: 'Listos',
  canceled: 'Historial',
  products: 'Bloqueo',
  creation_scheduled: 'Programados',
  rejected_order_manager: 'Rechazadas',
  order_taker: 'Tomar orden'
});

i18next.addResources('es_CR', 'SideBarItem', {
  created: 'Por aceptar',
  preparing: 'Preparación',
  ready: 'Listos',
  canceled: 'Historial',
  products: 'Bloqueo',
  creation_scheduled: 'Programados',
  rejected_order_manager: 'Rechazadas',
  order_taker: 'Tomar orden'
});
